import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["overrides", "variantOverrides", "variantFieldConfigs"];
import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { convertChirpFieldOverridesToJson } from 'ContentData/utils/chirp';
import { getHttpClientAsLastParam } from 'ContentData/helpers/apiHelpers';
import { getRpc, getPortalBufferRpc } from '../../__generated__/chirp/com/hubspot/global/styles/rpc/GlobalStylesRpc';
import { getByIdRpc as getPresetByIdRpc } from '../../__generated__/chirp/com/hubspot/content/themes/modules/rpc/ThemePresetRpc';
import PortalIdParser from 'PortalIdParser';
import { convertBindingsToJackson, convertOverridesToJackson, convertVariantDataToJackson } from '../utils/globalStyles';
export function fetchGlobalStylesFields(...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get('global/styles/v1/fields');
}
export async function fetchGlobalStylesObject({
  bufferTheme = false
} = {}, httpClient = http) {
  const rpcClient = createRpcClientV2({
    hubHttpClient: httpClient
  });
  const rpc = bufferTheme ? getPortalBufferRpc : getRpc;
  const {
    activePresetId,
    overrides
  } = await rpcClient.call(rpc, {
    request: {}
  });
  return {
    activePresetId,
    overrides: convertChirpFieldOverridesToJson(overrides !== null && overrides !== void 0 ? overrides : {})
  };
}
export async function fetchThemePreset(presetId, httpClient = http) {
  const rpcClient = createRpcClientV2({
    hubHttpClient: httpClient
  });
  const {
    styles
  } = await rpcClient.call(getPresetByIdRpc, {
    request: {
      id: presetId
    }
  });
  return convertChirpFieldOverridesToJson(styles !== null && styles !== void 0 ? styles : {});
}
export function fetchGlobalStylesCss({
  globalStyles,
  bufferTheme
} = {}) {
  let data = {};
  if (!bufferTheme && globalStyles) {
    const {
        overrides,
        variantOverrides,
        variantFieldConfigs
      } = globalStyles,
      rest = _objectWithoutPropertiesLoose(globalStyles, _excluded);
    data = {
      globalStyles: Object.assign({}, rest, {
        overrides: convertOverridesToJackson(overrides),
        variantOverrides: convertVariantDataToJackson(variantOverrides),
        variantFieldConfigs: convertBindingsToJackson(variantFieldConfigs),
        portalId: PortalIdParser.get()
      })
    };
  }
  return http.post('global-styles-rendering/v1/css', {
    query: {
      bufferTheme
    },
    data
  });
}
export const GET_CSS_VARS = registerQuery({
  fieldName: 'cssVars',
  args: ['globalStyles', 'bufferTheme'],
  fetcher: fetchGlobalStylesCss
});